import * as Yup from 'yup';

export const formValidationSchema = Yup.object({
    firstName: Yup.string()
    .required('First Name is required'),
    lastName: Yup.string()
    .required('Last Name is required'),
    email: Yup.string()
    .email('Invalid Email Address')
    .required('Email is required'),
    phone: Yup.string()
    .required('Phone Number is required'),
    message: Yup.string()
    .min(10, 'Mesasge should be at least 10 characters')
    .required('Message is Required')
});